// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-layout {
  --v-scrollbar-offset: 0px;
  display: flex;
  flex: 1 1 auto;
}
:where(.vuetify-styles) .v-layout--full-height {
  --v-scrollbar-offset: inherit;
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VLayout/VLayout.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,aAAa;EACb,cAAc;AAChB;AACA;EACE,6BAA6B;EAC7B,YAAY;AACd","sourcesContent":[".v-layout {\n  --v-scrollbar-offset: 0px;\n  display: flex;\n  flex: 1 1 auto;\n}\n.v-layout--full-height {\n  --v-scrollbar-offset: inherit;\n  height: 100%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
